export function batchPrintMode(url: string): string {
    // 체크할 3개의 배열
    const dev = [
                                "localhost:3000"
                            ,   "dev-edoc.postech.ac.kr"
                            ,   "devedoc.busanpa.com"
                        ];
    const qas = [
                                "localhost"
                        ];
    const prd = [
                                "edoc.postech.ac.kr"
                            ,   "edoc.busanpa.com"
                        ];

    // 각 배열에 변수명이 있는지 체크
    if (dev.includes(url)) {
        return "DEV";
    }
    if (qas.includes(url)) {
        return "QAS";
    }
    if (prd.includes(url)) {
        return "PRD";
    }

    // 모든 배열에 포함된 변수명이 없는 경우 null 반환
    return "PRD";
}